import { applyPromoOverride } from 'yoda-core-components/lib/helpers/Stylitics';
import { miniPDPOnDynamicGalleriesOpen } from 'yoda-site-components/lib/actions/MiniPDPAction';
import {
    dynamicGalleriesItemClick,
    dynamicGalleriesLoadSuccess,
    dynamicGalleriesModuleClick,
} from '../../../actions/AnalyticsActions';
import { getMappedStyliticsURL, getProductColorwayIDs } from '../../../helpers/GalleryHelper';

let _onOutfitsLoaded = null;
let _onItemClick = null;
let _onBundleClick = null;

const dynamicGalleriesConfig = {
    id: 'dynamic-galleries',
    containerId: 'dynamic-galleries-widget-container',
    title: null,
    requiresItemNumber: false,

    getScriptURL: (prefs) => prefs?.styliticsWidget?.scriptURL || '',

    createWidget: async (itemNumber, featureFlags, widgetParams = {}) => {
        const { catId, requestUrl, products, enableFallbackIDs, cardFooterText } = widgetParams;
        if (typeof StyliticsComposer === 'undefined') {
            throw new Error('StyliticsComposer is not available');
        }
        return StyliticsComposer.initialize({
            client: 'jcpenney',
            target: 'dynamic-galleries-widget-container',
            config: {
                modules: [
                    {
                        type: 'dynamic-galleries',
                        params: {
                            api: {
                                min: 3,
                                max: 6,
                                page: getMappedStyliticsURL(catId, requestUrl),
                                ids: enableFallbackIDs ? getProductColorwayIDs(products) : '',
                            },
                            display: {
                                viewItemsCTAText: cardFooterText,
                            },
                        },
                        on: {
                            'mount.outfits': ({ outfits }) => {
                                _onOutfitsLoaded?.(outfits);
                            },
                            'mount.item': ({ item, element }) => {
                                applyPromoOverride(element, item);
                            },
                            'click.bundle': ({ bundle }) => {
                                _onBundleClick?.(bundle);
                            },
                        },
                        override: {
                            'click.item': (data) => {
                                _onItemClick?.(data?.item, data?.outfit);
                            },
                        },
                    },
                ],
            },
        });
    },

    registerEvents: (instance, { onOutfitsLoaded, onItemClick, onBundleClick }) => {
        _onOutfitsLoaded = onOutfitsLoaded;
        _onItemClick = onItemClick;
        _onBundleClick = onBundleClick;
    },

    refresh: () => {},

    analyticsLoadAction: dynamicGalleriesLoadSuccess,
    analyticsClickAction: ({ id, ppId }) =>
        dynamicGalleriesItemClick({
            dynamicGalleryID: id?.toString() || '',
            dynamicGalleryPPID: ppId,
            moduleName: 'dynamic gallery',
        }),
    analyticsModuleClickAction: ({ id }) =>
        dynamicGalleriesModuleClick({
            dynamicGalleryID: id?.toString() || '',
        }),
    miniPDPAction: miniPDPOnDynamicGalleriesOpen,
    analyticsModule: 'dynamic gallery',
};

export default dynamicGalleriesConfig;
